import { render, staticRenderFns } from "./CartaoAprovadores.vue?vue&type=template&id=fce63162&scoped=true"
import script from "./CartaoAprovadores.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoAprovadores.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoAprovadores.vue?vue&type=style&index=0&id=fce63162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce63162",
  null
  
)

export default component.exports